export enum SparteType {
	SPARTE_MITGLIED = 'mitglied',
	SPARTE_SCHUTZBRIEF = 'schutzbrief'
}